// Le 14 categorie degli articoli, con etichetta e icona, e il gruppo che
// decide campi e unità di giacenza [sc-49299]. Le usano le card dei Listini,
// la pagina «Nuovo articolo» e la creazione dal preventivo.

export const CATEGORIE = [
  { slug: "piastrelle", label: "Piastrelle", icon: "fa-solid fa-border-all" },
  {
    slug: "rivestimenti parete",
    label: "Rivestimenti Parete",
    icon: "fa-solid fa-paint-roller",
  },
  { slug: "parquet", label: "Parquet", icon: "fa-solid fa-grip-horizontal" },
  { slug: "laminati", label: "Laminati", icon: "fa-solid fa-layer-group" },
  {
    slug: "decking esterno",
    label: "Decking Esterno",
    icon: "fa-solid fa-tree",
  },
  { slug: "box doccia", label: "Box Doccia", icon: "fa-solid fa-shower" },
  { slug: "sanitari", label: "Sanitari", icon: "fa-solid fa-toilet" },
  { slug: "rubinetteria", label: "Rubinetteria", icon: "fa-solid fa-faucet" },
  {
    slug: "accessori bagno",
    label: "Accessori Bagno",
    icon: "fa-solid fa-bath",
  },
  { slug: "profili", label: "Profili", icon: "fa-solid fa-minus" },
  {
    slug: "sistemi di scarico",
    label: "Sistemi di Scarico",
    icon: "fa-solid fa-water",
  },
  { slug: "mobili", label: "Mobili", icon: "fa-solid fa-couch" },
  {
    slug: "porte e infissi",
    label: "Porte e Infissi",
    icon: "fa-solid fa-door-open",
  },
  { slug: "altro", label: "Altro", icon: "fa-solid fa-box" },
];

// Stessi gruppi dell'API (utils/categoryGroups.js)
export const COLUMN_GROUPS = {
  area: [
    "piastrelle",
    "rivestimenti parete",
    "parquet",
    "laminati",
    "decking esterno",
  ],
  piece: ["sanitari", "rubinetteria", "box doccia", "accessori bagno"],
  linear: ["profili", "sistemi di scarico"],
  furniture: ["mobili", "porte e infissi"],
};

export function getCategoryGroup(category) {
  for (const [group, cats] of Object.entries(COLUMN_GROUPS)) {
    if (cats.includes(category)) return group;
  }
  return "generic";
}

/**
 * Come si chiede la giacenza iniziale: scatole per le categorie a superficie,
 * confezioni per le lineari (campo `boxQuantity`), pezzi per le altre
 * (`inWarehouse`). Le regole del calcolo sono nell'API (giacenzaIniziale).
 */
export function campoGiacenza(category) {
  const gruppo = getCategoryGroup(category);
  if (gruppo === "area") return { campo: "boxQuantity", label: "Scatole" };
  if (gruppo === "linear") return { campo: "boxQuantity", label: "Confezioni" };
  return { campo: "inWarehouse", label: "Pezzi" };
}

const vuoto = (v) => v === null || v === undefined || String(v).trim() === "";
const positivo = (v) => !vuoto(v) && Number(v) > 0;

/**
 * Errore sulla giacenza iniziale da mostrare sotto il campo, o null. Stessi
 * controlli dell'API, così l'errore si vede prima di salvare.
 */
export function erroreGiacenzaIniziale(category, form) {
  const { campo } = campoGiacenza(category);
  const valore = form[campo];
  if (vuoto(valore)) return null;
  if (!/^\d+$/.test(String(valore).trim())) {
    return "Scrivi un numero intero da 0 in su.";
  }
  if (Number(valore) === 0) return null;
  const gruppo = getCategoryGroup(category);
  if (
    gruppo === "area" &&
    !positivo(form.piecesPerBox) &&
    !positivo(form.sqmPerBox)
  ) {
    return "Per calcolare la giacenza servono i pezzi o i m² per scatola.";
  }
  if (gruppo === "linear" && !positivo(form.mlPerBox)) {
    return "Per calcolare i metri servono i ML per confezione.";
  }
  return null;
}

/**
 * La giacenza iniziale la mette chi gestisce prezzi e magazzino (PRICE_WRITE
 * nell'API); per Vendita l'articolo nuovo parte da 0 [sc-49299].
 */
export function puoCaricareGiacenza(role) {
  return role === "responsabile" || role === "direzione";
}
